import React from 'react';

const LogoFacebook = () => (
  <svg width="9" height="16" viewBox="0 0 9 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.40624426 15.999962V8.843729H0V5.999986h2.40624426V3.749991c0-1.187497.3333327-2.10937.99999762-2.765618C4.0729068.328124 4.95832167 0 6.06248555 0c.89583135 0 1.62499612.041666 2.18749478.125v2.531244H6.74998391c-.56249866 0-.94791425.124999-1.15624725.374999-.16666611.208333-.2499994.541665-.2499994.999997v1.968746h2.65624367l-.37499911 2.843743H5.34373726v7.156233h-2.937493z"
      fillRule="nonzero"
    />
  </svg>
);

export default LogoFacebook;
